import { cloudflareSiteKey } from "../common/environment";

export const HTTP_METHOD_GET = "GET";
export const HTTP_METHOD_POST = "POST";
export const HTTP_METHOD_PUT = "PUT";
export const HTTP_METHOD_DELETE = "DELETE";

export const CLOUDFLARE_SITE_KEY = cloudflareSiteKey;

export type HTTP_METHOD ={
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
};
